import styled from "@emotion/styled";

const ValidationError = styled.div`
  font-size: 12px;
  color: red;
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

export default ValidationError;
